import isClient from 'commons/isClient';

const requestIdleCallback = isClient()
  ? window.requestIdleCallback || (fn => setTimeout(fn, 0))
  : fn => fn();

export default requestIdleCallback;
